<script setup lang="ts">
defineProps<{
  specialty: string;
}>();
</script>

<template>
  <span :class="$style.chip">
    {{ specialty }}
  </span>
</template>

<style lang="scss" module>
.chip {
  border: solid $color-border-low-emphasis;
  border-radius: 50px;
  font-size: 14px;
  background-color: $color-surface-secondary;
  padding: 0 12px;
  height: 32px;
}
</style>
